
import HomeIntro from "@/components/home/HomeIntro.vue";
import HomeStats from "@/components/home/HomeStats.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  components: { HomeIntro, HomeStats },
});
